import {TheBorderXBombSymbol} from "../reels/TheBorderXBombSymbol";

/**
 * Created by Jerker Nord on 2022-05-05.
 */

export class TheBorderXBombSymbols {

    constructor() {
    }

    private _xBombSymbols: TheBorderXBombSymbol[];

    get xBombSymbols(): TheBorderXBombSymbol[] {
        return this._xBombSymbols;
    }

    private static createNewXBombSymbol(): TheBorderXBombSymbol {
        return new TheBorderXBombSymbol();
    }

    public init(): void {
        this._xBombSymbols = [];
        for (let i: number = 0; i < 6; i++) {
            this._xBombSymbols.push(TheBorderXBombSymbols.createNewXBombSymbol());
        }
    }

    public getSymbol(): TheBorderXBombSymbol {
        for (let i: number = 0; i < this._xBombSymbols.length; i++) {
            if (!this._xBombSymbols[i].isUsed) {
                this._xBombSymbols[i].isUsed = true;
                return this._xBombSymbols[i];
            }
        }
        this._xBombSymbols.push(TheBorderXBombSymbols.createNewXBombSymbol());
        return this.getSymbol();
    }

    public turnOffAllXBombSymbols(): void {
        for (let i: number = 0; i < this._xBombSymbols.length; i++) {
            if (this._xBombSymbols[i].isUsed) {
                this._xBombSymbols[i].turnOffSymbolSpine();
            }
        }
    }
}